module.exports = __webpack_public_path__ + "media/images/clear-check-65f9df17e9e68f18a12d98cd3fa8dd70.svg";